import React from 'react'
import './CommentSection.css'
import StudentWork from '../StudentWork/StudentWork';
const CommentSection = ({comments}) => {
 


/* const orderedDiscussion = orderByOldest(discussion); */
  return (
    <div className='CommentSection-container'>
      <h1 style={{color : '#3A3845',fontSize : "2em"}}> Comments :</h1>
        {comments?.map((e)=> <StudentWork  Submission={e}/>)}
       
       
    </div>
  )
}

function orderByOldest(messages) {

  return messages.sort(
    (a, b) => new Date(a.DateOfSubmission) - new Date(b.DateOfSubmission)
  );
}

export default CommentSection
